export default function LoadingSkeleton({ layout = "list", label = "Loading" }: {
  layout?: "insights" | "accounts" | "list" | "detail";
  label?: string;
}) {
  const rows = Array.from({ length: layout === "detail" ? 3 : 5 }, (_, index) => index);
  return (
    <div className={`loading-skeleton skeleton-${layout}`} role="status" aria-label={label} aria-busy="true">
      <div aria-hidden="true">
        <div className="skeleton-title skeleton-piece" />
        {(layout === "insights" || layout === "accounts") && <div className="skeleton-cards">
          {[0, 1].map(index => <div key={index} className="skeleton-card">
            <div className="skeleton-caption skeleton-piece" />
            <div className="skeleton-amount skeleton-piece" />
            <div className="skeleton-bar skeleton-piece" />
          </div>)}
        </div>}
        {layout === "insights" && <div className="skeleton-chart">
          {[35, 60, 45, 80, 55, 70, 90].map((height, index) => <i key={index} className="skeleton-piece" style={{ height: `${height}%` }} />)}
        </div>}
        <div className="skeleton-rows">
          {rows.map(index => <div key={index} className="skeleton-row">
            <div className="skeleton-avatar skeleton-piece" />
            <div><div className="skeleton-name skeleton-piece" /><div className="skeleton-caption skeleton-piece" /></div>
            <div className="skeleton-value skeleton-piece" />
          </div>)}
        </div>
      </div>
    </div>
  );
}
